export namespace TField {
  export const ROOM_TYPE_AUDIO = 'audio'; // 音频房间
  export const ROOM_TYPE_VIDEO = 'video'; // 视频房间
  export type RoomType = typeof ROOM_TYPE_AUDIO | typeof ROOM_TYPE_VIDEO;

  export const MEETING_TYPE_BOOKING = 2; // 预约会议
  export const MEETING_TYPE_QUICK = 5; // 快速会议
  export const MEETING_TYPE_LIVE = 6; // 直播会议
  export type MeetingType = typeof MEETING_TYPE_BOOKING | typeof MEETING_TYPE_QUICK | typeof MEETING_TYPE_LIVE;

  export const READY_MODE_OFF = 0; // 不开启 准备就绪模式
  export const READY_MODE_ON = 1; // 开启 准备就绪模式
  export type ReadyMode = typeof READY_MODE_OFF | typeof READY_MODE_ON;

  // 会议重复类型
  export const MEET_REPEAT_TYPE_NONE = 'none'; // 不重复
  export const MEET_REPEAT_TYPE_DAY = 'day'; // 每天重复
  export const MEET_REPEAT_TYPE_WEEK = 'week'; // 每周重复
  export const MEET_REPEAT_TYPE_MONTH = 'month'; // 每月重复
  export const MEET_REPEAT_TYPE_YEAR = 'year'; // 每年重复
  export const MEET_REPEAT_TYPE_WORK = 'work'; // 每工作日 会管后端不支持
  export type MeetRepeatType =
    | typeof MEET_REPEAT_TYPE_NONE
    | typeof MEET_REPEAT_TYPE_DAY
    | typeof MEET_REPEAT_TYPE_WEEK
    | typeof MEET_REPEAT_TYPE_MONTH
    | typeof MEET_REPEAT_TYPE_YEAR
    | typeof MEET_REPEAT_TYPE_WORK
    | '';

  // 会议房间状态
  export const ROOM_MEET_STATUS_CREATE = 1; // 已创建房间
  export const ROOM_MEET_STATUS_DOING = 2; // 房间会议进行中
  export const ROOM_MEET_STATUS_CLOSE = 3; // 房间会议已关闭
  export type RoomMeetStatus =
    | typeof ROOM_MEET_STATUS_CREATE
    | typeof ROOM_MEET_STATUS_DOING
    | typeof ROOM_MEET_STATUS_CLOSE;

  // 用户在会议中的状态
  export const USER_MEET_STATUS_1 = 1; // 已经发了join Room，但是没有从webrtc加入房间
  export const USER_MEET_STATUS_2 = 2; // 已加入 （加入）
  export const USER_MEET_STATUS_3 = 3; // 已拒接 （取消）
  export const USER_MEET_STATUS_4 = 4; // 对方忙 （会议中，呼叫超时）
  export const USER_MEET_STATUS_5 = 5; // 呼叫中
  export const USER_MEET_STATUS_6 = 6; // 呼叫超时
  export const USER_MEET_STATUS_7 = 7; // 离开
  export const USER_MEET_STATUS_8 = 8; // 连接中
  export const USER_MEET_STATUS_9 = 9; // 预定
  export type UserMeetStatus =
    | typeof USER_MEET_STATUS_1
    | typeof USER_MEET_STATUS_2
    | typeof USER_MEET_STATUS_3
    | typeof USER_MEET_STATUS_4
    | typeof USER_MEET_STATUS_5
    | typeof USER_MEET_STATUS_6
    | typeof USER_MEET_STATUS_7
    | typeof USER_MEET_STATUS_8
    | typeof USER_MEET_STATUS_9;

  // 用户登录后的角色
  export const USER_POWSER_NORMAL = 0; // 非管理员
  export const USER_POWSER_ADMIN = 1; // 管理员
  export type UserPowser = typeof USER_POWSER_NORMAL | typeof USER_POWSER_ADMIN;

  // 登录方式
  export const GRANT_TYPE_PASSWORD = 'password';
  export const GRANT_TYPE_MEETING = 'meeting';
  export const GRANT_TYPE_RECORD = 'record';
  export type GrantType = typeof GRANT_TYPE_PASSWORD | typeof GRANT_TYPE_MEETING | typeof GRANT_TYPE_RECORD;

  export const MEET_AUTO_MUTE_OPEN = 'open'; // 入会打开麦克风
  export const MEET_AUTO_MUTE_CLOSE = 'close'; // 入会关闭麦克风
  export const MEET_AUTO_MUTE_EXCEED = 'exceed'; // 超过一定人数关闭麦克风（现在限制6人及以上）
  export type MeetAutoMute = typeof MEET_AUTO_MUTE_OPEN | typeof MEET_AUTO_MUTE_CLOSE | typeof MEET_AUTO_MUTE_EXCEED;

  // 国际化语言
  export const LANGUAGE_EN = 'en';
  export const LANGUAGE_ZH = 'zh';
  export type Language = typeof LANGUAGE_EN | typeof LANGUAGE_ZH;

  // 用户登录方式
  export const LOGIN_METHOD_LOCAL = 'local'; // 本地认证登录
  export const LOGIN_METHOD_THIRD = 'third'; // 三方认证登录
  export type LoginMethod = typeof LOGIN_METHOD_LOCAL | typeof LOGIN_METHOD_THIRD;

  // 会议参与者范围
  export const MEET_RANGE_ALL = 'all'; // 全部
  export const MEET_RANGE_NOTBOOKING = 'notBooking'; // 不是预定的人员
  export const MEET_RANGE_REALITY_JOIN = 'realityJoin'; // 实际加入人员
  export type MeetRange = typeof MEET_RANGE_ALL | typeof MEET_RANGE_NOTBOOKING | typeof MEET_RANGE_REALITY_JOIN;

  // 主题
  export const COLOR_THEME_LIGHT = 'light'; // 浅色
  export const COLOR_THEME_DARK = 'dark'; // 深色
  export type ColorTheme = typeof COLOR_THEME_LIGHT | typeof COLOR_THEME_DARK;
}
